import React, { FunctionComponent } from 'react';

import styles from './index.module.scss';
type Props = {
  type;
  value;
};

const TypeValueRow: FunctionComponent<Props> = ({ type, value }) => {
  return (
    <div className={styles.root}>
      <div className={'bold'}>{type}</div>
      <div className={'bold'}>{value}</div>
    </div>
  );
};

export default React.memo(TypeValueRow);
